import React from 'react';

import "./manning-online-tour.scss";
import { ManningOnlineTourModal, TourModalStep } from './ManningOnlineTourModal';

export interface IProps {
    onClose: () => void;
}

export interface IState {}

export class ManningOnlineDesktopTourModal extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);
    }

    public render(){
        return <ManningOnlineTourModal isOpen={true}
                                       key="manning-online-desktop-tour"
                                       onClose={this.props.onClose} 
                                       tourModalStep={TourModalStep.Media}
                                       mediaInfo={{
                                        path: "https://d19npu3b8zepp3.cloudfront.net/assets/manningOnlineTour/desktop.mp4",
                                        subtitlePath: "https://d19npu3b8zepp3.cloudfront.net/assets/manningOnlineTour/desktop.vtt",
                                        width: 1224,
                                        height: 704,
                                        playbackRate: 0.7
                                       }}/>
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
    }
}